module.exports = __webpack_public_path__ + "static/avatar-39de3f3b16a5d13b2d6e46139c02b1a8.png";